export default __webpack_public_path__ + "static/media/11.58024d23.svg";